export default "__VITE_ASSET__DwJmziOD__"